import React from 'react';
import {
    StyledTestimonialText,
    StyledTestimonialWrapper,
    StyledTestimonialName,
    StyledQuoteIcon,
    StyledContentWrapper,
} from './testimonial-slider.style';
import { __ } from '../../../utils/translation-service';
export interface ITestimonial {
    quote: string;
    name: string;
    time: string;
    additionalInfo: string;
}

export const Testimonial = ({ quote, name, time, additionalInfo }: ITestimonial) => {
    const formattedAdditionalInfo = __('additionalReviewInfo').replace(
        '[additionalInfo]',
        additionalInfo,
    );
    return (
        <StyledTestimonialWrapper>
            <StyledQuoteIcon startQuote />
            <StyledContentWrapper>
                <StyledTestimonialText>{quote}</StyledTestimonialText>
                <StyledTestimonialName>
                    {`${name}${time || ''}, ${formattedAdditionalInfo}`}
                </StyledTestimonialName>
            </StyledContentWrapper>
            <StyledQuoteIcon />
        </StyledTestimonialWrapper>
    );
};
